<template>
  <modal :show="show" @close="handleCancel">
    <div id="manual-entry-modal" slot="header" class="modal-header">
      <h5 class="modal-title">Manual Entry Reason</h5>
      <button id="btn-manual-entry-close" type="button" class="close" @click="handleCancel" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">
      <p class="alert alert-danger" v-if="error">{{ error }}</p>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            value="Barcode damaged"
            id="manual-entry-one"
            v-model="manualEntryReason"
          />
          <label class="form-check-label" for="manual-entry-one"> Barcode damaged </label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            value="Barcode not available"
            id="manual-entry-two"
            v-model="manualEntryReason"
          />
          <label class="form-check-label" for="manual-entry-two"> Barcode not available </label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            value="Barcode would not scan"
            id="manual-entry-three"
            v-model="manualEntryReason"
          />
          <label class="form-check-label" for="manual-entry-three"> Barcode would not scan </label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="manual-entry-four"
            value="Other"
            v-model="manualEntryReason"
          />
          <label class="form-check-label" for="manual-entry-four"> Other </label>
        </div>
      </div>
      <div class="form-group" v-if="manualEntryReason === 'Other'">
        <textarea
          class="form-control"
          :class="{ 'alert-danger': error }"
          placeholder="Enter comments"
          v-model="comment"
        ></textarea>
      </div>
    </div>

    <template v-slot:footer>
      <button id="btn-manual-entry-cancel" type="reset" class="btn btn-light" @click="handleCancel">Cancel</button>
      <button id="btn-manual-entry-ok" type="submit" class="btn btn-primary" @click="handleOk">OK</button>
    </template>
  </modal>
</template>

<script>
import Modal from "../Modal";
import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";

export default {
  name: "ManualEntryModal",
  props: ["show", "barcode"],
  data() {
    return {
      manualEntryReason: "",
      comment: "",
      error: ""
    };
  },
  methods: {
    async submit() {
      const reason = this.manualEntryReason === "Other" ? this.comment : this.manualEntryReason;
      try {
        await CoreAPI.sendManualEntryReason(reason, this.barcode);
        this.manualEntryReason = "";
        this.comment = "";
        this.$emit("close", { cancel: false });
      } catch (error) {
        if (error.isNetworkError) {
          this.error = modals.lostConnectionText;
        } else {
          this.error = modals.unexpectedErrorText;
        }
      }
    },
    handleOk: function(evt) {
      evt.preventDefault();
      if (this.manualEntryReason) {
        if (this.manualEntryReason === "Other" && this.comment === "") {
          this.error = "Please provide a comment.";
        } else {
          this.submit();
        }
      } else {
        this.error = "Please select a reason for manual entry.";
      }
    },
    handleCancel() {
      this.$emit("close", { cancel: true });
    }
  },
  components: {
    modal: Modal
  }
};
</script>

<style scoped></style>
